<div class="squares-container">
  <div class="square-layout">
    <div [routerLink]="'/doggoshop'" class="square-base card-size-resp square-doggoshop">
      <div>Doggo</div>
      <div>Shop</div>
    </div>
    <div [routerLink]="'/doggowash'" class="square-base card-size-resp square-doggowash">
      <div>Doggo</div>
      <div>Wash</div>
    </div>
  </div>

  <div class="square-layout">
    <div [routerLink]="'/doggocafe'" class="square-base card-size-resp square-doggocafe">
      <div>Doggo</div>
      <div>Café</div>
    </div>
    <div [routerLink]="'/doggoevents'" class="square-base card-size-resp square-doggoevents">
      <div>Doggo</div>
      <div>Events</div>
    </div>
  </div>
</div>

<!--<div class="wrapper-cards-mobile">-->
<!--  <app-cards-doggoverse-mobile></app-cards-doggoverse-mobile>-->
<!--</div>-->
